import React, { PureComponent } from 'react';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';

export class LayersIcon extends PureComponent<
    Pick<
        AntdIconProps,
        | 'max'
        | 'required'
        | 'high'
        | 'low'
        | 'disabled'
        | 'default'
        | 'start'
        | 'open'
        | 'media'
        | 'hidden'
        | 'cite'
        | 'data'
        | 'dir'
        | 'form'
        | 'label'
        | 'slot'
        | 'span'
        | 'style'
        | 'summary'
        | 'title'
        | 'pattern'
        | 'async'
        | 'defer'
        | 'manifest'
        | 'color'
        | 'content'
        | 'size'
        | 'wrap'
        | 'multiple'
        | 'key'
        | 'children'
        | 'list'
        | 'step'
        | 'aria-label'
        | 'spin'
        | 'rotate'
        | 'accept'
        | 'acceptCharset'
        | 'action'
        | 'allowFullScreen'
        | 'allowTransparency'
        | 'alt'
        | 'as'
        | 'autoComplete'
        | 'autoFocus'
        | 'autoPlay'
        | 'capture'
        | 'cellPadding'
        | 'cellSpacing'
        | 'charSet'
        | 'challenge'
        | 'checked'
        | 'classID'
        | 'cols'
        | 'colSpan'
        | 'controls'
        | 'coords'
        | 'crossOrigin'
        | 'dateTime'
        | 'download'
        | 'encType'
        | 'formAction'
        | 'formEncType'
        | 'formMethod'
        | 'formNoValidate'
        | 'formTarget'
        | 'frameBorder'
        | 'headers'
        | 'height'
        | 'href'
        | 'hrefLang'
        | 'htmlFor'
        | 'httpEquiv'
        | 'integrity'
        | 'keyParams'
        | 'keyType'
        | 'kind'
        | 'loop'
        | 'marginHeight'
        | 'marginWidth'
        | 'maxLength'
        | 'mediaGroup'
        | 'method'
        | 'min'
        | 'minLength'
        | 'muted'
        | 'name'
        | 'nonce'
        | 'noValidate'
        | 'optimum'
        | 'placeholder'
        | 'playsInline'
        | 'poster'
        | 'preload'
        | 'readOnly'
        | 'rel'
        | 'reversed'
        | 'rows'
        | 'rowSpan'
        | 'sandbox'
        | 'scope'
        | 'scoped'
        | 'scrolling'
        | 'seamless'
        | 'selected'
        | 'shape'
        | 'sizes'
        | 'src'
        | 'srcDoc'
        | 'srcLang'
        | 'srcSet'
        | 'target'
        | 'type'
        | 'useMap'
        | 'value'
        | 'width'
        | 'wmode'
        | 'defaultChecked'
        | 'defaultValue'
        | 'suppressContentEditableWarning'
        | 'suppressHydrationWarning'
        | 'accessKey'
        | 'className'
        | 'contentEditable'
        | 'contextMenu'
        | 'draggable'
        | 'id'
        | 'lang'
        | 'spellCheck'
        | 'tabIndex'
        | 'translate'
        | 'radioGroup'
        | 'role'
        | 'about'
        | 'datatype'
        | 'inlist'
        | 'prefix'
        | 'property'
        | 'resource'
        | 'typeof'
        | 'vocab'
        | 'autoCapitalize'
        | 'autoCorrect'
        | 'autoSave'
        | 'itemProp'
        | 'itemScope'
        | 'itemType'
        | 'itemID'
        | 'itemRef'
        | 'results'
        | 'security'
        | 'unselectable'
        | 'inputMode'
        | 'is'
        | 'aria-activedescendant'
        | 'aria-atomic'
        | 'aria-autocomplete'
        | 'aria-busy'
        | 'aria-checked'
        | 'aria-colcount'
        | 'aria-colindex'
        | 'aria-colspan'
        | 'aria-controls'
        | 'aria-current'
        | 'aria-describedby'
        | 'aria-details'
        | 'aria-disabled'
        | 'aria-dropeffect'
        | 'aria-errormessage'
        | 'aria-expanded'
        | 'aria-flowto'
        | 'aria-grabbed'
        | 'aria-haspopup'
        | 'aria-hidden'
        | 'aria-invalid'
        | 'aria-keyshortcuts'
        | 'aria-labelledby'
        | 'aria-level'
        | 'aria-live'
        | 'aria-modal'
        | 'aria-multiline'
        | 'aria-multiselectable'
        | 'aria-orientation'
        | 'aria-owns'
        | 'aria-placeholder'
        | 'aria-posinset'
        | 'aria-pressed'
        | 'aria-readonly'
        | 'aria-relevant'
        | 'aria-required'
        | 'aria-roledescription'
        | 'aria-rowcount'
        | 'aria-rowindex'
        | 'aria-rowspan'
        | 'aria-selected'
        | 'aria-setsize'
        | 'aria-sort'
        | 'aria-valuemax'
        | 'aria-valuemin'
        | 'aria-valuenow'
        | 'aria-valuetext'
        | 'dangerouslySetInnerHTML'
        | 'onCopy'
        | 'onCopyCapture'
        | 'onCut'
        | 'onCutCapture'
        | 'onPaste'
        | 'onPasteCapture'
        | 'onCompositionEnd'
        | 'onCompositionEndCapture'
        | 'onCompositionStart'
        | 'onCompositionStartCapture'
        | 'onCompositionUpdate'
        | 'onCompositionUpdateCapture'
        | 'onFocus'
        | 'onFocusCapture'
        | 'onBlur'
        | 'onBlurCapture'
        | 'onChange'
        | 'onChangeCapture'
        | 'onBeforeInput'
        | 'onBeforeInputCapture'
        | 'onInput'
        | 'onInputCapture'
        | 'onReset'
        | 'onResetCapture'
        | 'onSubmit'
        | 'onSubmitCapture'
        | 'onInvalid'
        | 'onInvalidCapture'
        | 'onLoad'
        | 'onLoadCapture'
        | 'onError'
        | 'onErrorCapture'
        | 'onKeyDown'
        | 'onKeyDownCapture'
        | 'onKeyPress'
        | 'onKeyPressCapture'
        | 'onKeyUp'
        | 'onKeyUpCapture'
        | 'onAbort'
        | 'onAbortCapture'
        | 'onCanPlay'
        | 'onCanPlayCapture'
        | 'onCanPlayThrough'
        | 'onCanPlayThroughCapture'
        | 'onDurationChange'
        | 'onDurationChangeCapture'
        | 'onEmptied'
        | 'onEmptiedCapture'
        | 'onEncrypted'
        | 'onEncryptedCapture'
        | 'onEnded'
        | 'onEndedCapture'
        | 'onLoadedData'
        | 'onLoadedDataCapture'
        | 'onLoadedMetadata'
        | 'onLoadedMetadataCapture'
        | 'onLoadStart'
        | 'onLoadStartCapture'
        | 'onPause'
        | 'onPauseCapture'
        | 'onPlay'
        | 'onPlayCapture'
        | 'onPlaying'
        | 'onPlayingCapture'
        | 'onProgress'
        | 'onProgressCapture'
        | 'onRateChange'
        | 'onRateChangeCapture'
        | 'onSeeked'
        | 'onSeekedCapture'
        | 'onSeeking'
        | 'onSeekingCapture'
        | 'onStalled'
        | 'onStalledCapture'
        | 'onSuspend'
        | 'onSuspendCapture'
        | 'onTimeUpdate'
        | 'onTimeUpdateCapture'
        | 'onVolumeChange'
        | 'onVolumeChangeCapture'
        | 'onWaiting'
        | 'onWaitingCapture'
        | 'onAuxClick'
        | 'onAuxClickCapture'
        | 'onClick'
        | 'onClickCapture'
        | 'onContextMenu'
        | 'onContextMenuCapture'
        | 'onDoubleClick'
        | 'onDoubleClickCapture'
        | 'onDrag'
        | 'onDragCapture'
        | 'onDragEnd'
        | 'onDragEndCapture'
        | 'onDragEnter'
        | 'onDragEnterCapture'
        | 'onDragExit'
        | 'onDragExitCapture'
        | 'onDragLeave'
        | 'onDragLeaveCapture'
        | 'onDragOver'
        | 'onDragOverCapture'
        | 'onDragStart'
        | 'onDragStartCapture'
        | 'onDrop'
        | 'onDropCapture'
        | 'onMouseDown'
        | 'onMouseDownCapture'
        | 'onMouseEnter'
        | 'onMouseLeave'
        | 'onMouseMove'
        | 'onMouseMoveCapture'
        | 'onMouseOut'
        | 'onMouseOutCapture'
        | 'onMouseOver'
        | 'onMouseOverCapture'
        | 'onMouseUp'
        | 'onMouseUpCapture'
        | 'onSelect'
        | 'onSelectCapture'
        | 'onTouchCancel'
        | 'onTouchCancelCapture'
        | 'onTouchEnd'
        | 'onTouchEndCapture'
        | 'onTouchMove'
        | 'onTouchMoveCapture'
        | 'onTouchStart'
        | 'onTouchStartCapture'
        | 'onPointerDown'
        | 'onPointerDownCapture'
        | 'onPointerMove'
        | 'onPointerMoveCapture'
        | 'onPointerUp'
        | 'onPointerUpCapture'
        | 'onPointerCancel'
        | 'onPointerCancelCapture'
        | 'onPointerEnter'
        | 'onPointerEnterCapture'
        | 'onPointerLeave'
        | 'onPointerLeaveCapture'
        | 'onPointerOver'
        | 'onPointerOverCapture'
        | 'onPointerOut'
        | 'onPointerOutCapture'
        | 'onGotPointerCapture'
        | 'onGotPointerCaptureCapture'
        | 'onLostPointerCapture'
        | 'onLostPointerCaptureCapture'
        | 'onScroll'
        | 'onScrollCapture'
        | 'onWheel'
        | 'onWheelCapture'
        | 'onAnimationStart'
        | 'onAnimationStartCapture'
        | 'onAnimationEnd'
        | 'onAnimationEndCapture'
        | 'onAnimationIteration'
        | 'onAnimationIterationCapture'
        | 'onTransitionEnd'
        | 'onTransitionEndCapture'
        | 'twoToneColor'
    > &
        React.RefAttributes<HTMLSpanElement>
> {
    render() {
        return (
            <span role="img" aria-label="not-allowed" className="anticon anticon-not-allowed" {...this.props}>
                <svg
                    width="2em"
                    height="2em"
                    // viewBox="0 0 421.59 421.59"
                    viewBox="0 0 896 896"
                    focusable="false"
                    data-icon="not-allowed"
                    fill="currentColor"
                    aria-hidden="true">
                    {/*<rect x="2" y="2" width="419" height="419" rx="120" stroke="none"/>*/}
                    <rect x="3" y="3" width="890" height="890" rx="120" stroke="none" />
                    <g>
                        <g transform="scale(0.9) translate(20 20)">
                            <path
                                fill="black"
                                d="m818.67122,606.70263l-116.19837,-72.74613l116.19639,-72.73629c4.31315,-2.69926 6.93065,-7.41902 6.93065,-12.49488s-2.6175,-9.79562 -6.93065,-12.49685l-116.19837,-72.7481l116.19245,-72.74023c4.31315,-2.70122 6.93065,-7.41902 6.93065,-12.49488s-2.6175,-9.79562 -6.93065,-12.49488l-366.57609,-229.48988c-4.81256,-3.01404 -10.93585,-3.01404 -15.75039,0l-366.57609,229.48988c-4.31315,2.70122 -6.93065,7.41902 -6.93065,12.49488c0,5.07586 2.6175,9.79562 6.93065,12.49488l116.19047,72.73826l-116.18652,72.75006c-4.31315,2.70122 -6.92867,7.41902 -6.92867,12.49488c0,5.07586 2.6175,9.79562 6.93065,12.49488l116.18652,72.73432l-116.18652,72.75203c-4.31315,2.69926 -6.92867,7.41902 -6.92867,12.49488c0,5.07586 2.6175,9.79562 6.93065,12.49488l366.5682,229.4761c2.40826,1.50702 5.14025,2.26053 7.87421,2.26053s5.46793,-0.75351 7.87421,-2.26053l366.58596,-229.47807c4.31315,-2.69926 6.93065,-7.41902 6.93065,-12.49488c0,-5.07586 -2.6175,-9.79562 -6.93065,-12.49488zm-713.20314,-328.45735l338.74494,-212.06472l338.74297,212.06472l-338.74297,212.06472l-338.74494,-212.06472zm0.00395,170.47611l108.31034,-67.81782l222.55447,139.32646c2.40628,1.50702 5.14025,2.26053 7.87421,2.26053c2.73396,0 5.46793,-0.75351 7.87421,-2.26053l222.55052,-139.3245l108.32219,67.81586l-338.74889,212.05292l-338.73705,-212.05292zm338.73705,382.52707l-338.73705,-212.05292l108.31232,-67.81979l222.55052,139.31859c2.40826,1.50702 5.14025,2.26053 7.87421,2.26053s5.46793,-0.75351 7.87421,-2.26053l222.55447,-139.31466l108.32416,67.81586l-338.75284,212.05292z"
                            />
                        </g>
                    </g>
                </svg>
            </span>
        );
    }
}
